import { render } from "./TreeViewIconsPreview.vue?vue&type=template&id=8c915726"
import script from "./TreeViewIconsPreview.vue?vue&type=script&lang=js"
export * from "./TreeViewIconsPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__